module.exports = {"PHOTO_GRID_NOT_LOADED_IMAGES_MESSAGE":"Chúng tôi không thể tải một vài hình ảnh trên bài post của bạn về"}